import React from "react";
import { Loader2, PlayCircle, RotateCcw } from "lucide-react";

export const ActiveSessionDialog = ({ detail, busy, onResume, onStartOver, onCancel }) => {
  if (!detail) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" data-testid="active-session-dialog">
      <div className="w-full max-w-md rounded-2xl border border-zinc-800 bg-zinc-950 p-6 shadow-2xl">
        <div className="text-[10px] uppercase tracking-[0.28em] text-amber-400 mb-2">Interview in progress</div>
        <h3 className="text-lg font-semibold text-zinc-50">You already have an interview underway</h3>
        <p className="text-sm text-zinc-400 mt-2 leading-relaxed">
          {detail.job_title ? (
            <>Your interview for <span className="text-zinc-200">{detail.job_title}{detail.company ? ` @ ${detail.company}` : ""}</span> hasn&apos;t been finished yet.</>
          ) : (
            <>Your previous interview hasn&apos;t been finished yet.</>
          )}{" "}
          Pick up where you left off, or start over with a fresh session.
        </p>
        <div className="flex flex-col gap-2 mt-5">
          <button
            onClick={onResume}
            disabled={busy}
            data-testid="resume-session-btn"
            className="inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 text-amber-950 font-semibold rounded-lg px-4 py-2.5 text-sm disabled:opacity-60"
          >
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <PlayCircle className="h-4 w-4" />}
            Resume existing interview
          </button>
          <button
            onClick={onStartOver}
            disabled={busy}
            data-testid="start-over-btn"
            className="inline-flex items-center justify-center gap-2 border border-zinc-700 hover:border-zinc-500 text-zinc-200 rounded-lg px-4 py-2.5 text-sm disabled:opacity-60"
          >
            <RotateCcw className="h-4 w-4" />
            Start over
          </button>
          <button
            onClick={onCancel}
            disabled={busy}
            data-testid="active-session-cancel-btn"
            className="text-xs text-zinc-500 hover:text-zinc-300 mt-1"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
